import { getLoginUser } from "@common/utils"
import { getProjectId } from "@common/utils"
import { createCascade, queryActivity } from "@common/api"
import { getLiveLists, getVideoLists } from "@common/api"
import myalert from "@common/utils/myalert"
import ajax from "@common/utils/ajax"
import { getFriendLink } from "@common/api"
import { getCookie, setCookie } from "@common/utils"
import { jsonParseSafe } from "@common/utils"
import { getSession, setSession } from "../../../../common/utils"

const state = {
  isDesMobile: false,
  user: {},
  activity: jsonParseSafe(getCookie("activity")),
  projectId: "",
  lang: sessionStorage.getItem("lang") || "zh",
  visibleLogin: false, //登陆弹出框
  liveList: [],
  videoList: [],
  friendLink: [],
  webColunmsList: [], //网页路径
  colunmsListObject: {},
  recommendedPopupShow: true,
  commitLiveShow: true,
  exhibitsListPageNum: 1
}

const mutations = {
  set_exhibitsListPageNum (state, pageNum) {
    state.exhibitsListPageNum = pageNum
  },
  set_commitmentLiveShow (state, commitLiveShow) {
    setCookie("set_commitLiveShow", "set_commitLiveShow")
    state.commitLiveShow = commitLiveShow
  },
  set_recommendedPopupShow (state, recommendedPopupShow) {
    setCookie("set_recommendedPopupShow", 1111111)
    state.recommendedPopupShow = recommendedPopupShow
  },
  show_visibleLogin (state, visibleLogin) {
    state.visibleLogin = true
  },
  close_visibleLogin (state, visibleLogin) {
    state.visibleLogin = false
  },
  UPDATE_PASS_DIALOG: (state, val) => {
    state.passwordDialog = val
  },
  UPDATE_CURRENT_USER: (state, user) => {
    state.user = user
  },
  projectId (state, projectId) {
    state.projectId = projectId
  },
  activity (state, activity) {
    state.activity = activity
  },
  liveList (state, liveList) {
    state.liveList = liveList
  },
  videoList (state, videoList) {
    state.videoList = videoList
  },
  friendLink (state, friendLink) {
    state.friendLink = friendLink
  },
  webColunmsList (state, webColunmsList) {
    state.webColunmsList = webColunmsList
  },
  colunmsListObject (state, colunmsListObject) {
    state.colunmsListObject = colunmsListObject
  }
}

const actions = {
  updatePasswordDialog ({ commit }, val) {
    commit("UPDATE_PASS_DIALOG", val)
  },
  action_init_flow ({ dispatch, commit }) {
    var projectId = window._vm.$route.query.projectId || getProjectId()
    commit("projectId", projectId)
    dispatch("action_get_loginUser")
    dispatch("action_getactivity")

    dispatch("action_get_web_columnsList")
    dispatch("initFriendLink")
  },
  action_get_loginUser ({ commit }) {
    const user = getLoginUser()
    commit("UPDATE_CURRENT_USER", user)
  },
  action_getactivity ({ commit, state }) {
    let params = {
      projectId: sessionStorage.getItem("projectId") || getProjectId()
    }
    queryActivity(params).then(res => {
      if (res && res.data) {
        var activity = res.data
        commit("activity", activity)
        setCookie("activity", JSON.stringify(activity))
        if (state.lang == "zh") {
          // document.title = activity.short_code === 'laobao' ? '劳保会' : 'VIRTUAL CERAMIC CONNECT';
        } else {
          // document.title = activity.short_code === 'laobao' ? 'CIOSH VIRTUAL' : 'VIRTUAL CERAMIC CONNECT';
        }
      }
    })
  },
  async actions_getLiveList ({ state, dispatch, commit }) {
    var result = await getLiveLists(state.projectId).catch(e => {
      console.warn("actions_getLiveList", e)
      return { code: 401, result: { data: [] } }
    })
    if (result.code != 0) {
      return false
    }
    console.log("liveList", result.result.data)
    var liveList = result.result.data
    liveList = liveList.map(item => {
      item.type = "live"
      return item
    })
    commit("liveList", liveList)
    return result
  },
  async initFriendLink ({ state, commit }) {
    // var list = jsonParseSafe(getSession("friendLink"));
    // if (!list || list.length == 0) {
    var list = await getFriendLink({
      pageNum: 1,
      pageSize: 999,
      type: 4,
      types: "",
      projectId: getProjectId()
    }).then(res => res.result && res.result.data)

    // }

    // for (let i = 0; i < list.length; i++) {
    //   // /api3/column/getColumnById/{id}
    //   var item = await ajax
    //     .get(`/api3/column/getColumnById/${list[i].id}`)
    //     .then(res => res.data)
    //     .then(res => {
    //       return res.result;
    //     });
    //   list[i] = {
    //     ...list[i],
    //     ...item
    //   };
    // } detailList
    let linkList = list && list[0] && list[0].detailList
    if (!linkList) {
      return false
    }

    setSession("friendLink", list)
    commit("friendLink", linkList)

    return linkList
  },
  async queryVideoList ({ state, commit, dispatch }) {
    let params = {
      pageNum: 1,
      projectId: getProjectId(),
      pageSize: 9
    }
    var result = await getVideoLists(params)
    if (result.code != 0) {
      return false
    }
    console.log(result)
    var videoList = result.result.data
    videoList = videoList.map(item => {
      item.type = "video"
      return item
    })
    commit("videoList", videoList)
    console.log("videoList", videoList)
  },
  action_getLiveListAndVideoList ({ dispatch }) {
    return dispatch("queryVideoList").then(() => {
      return dispatch("actions_getLiveList")
    })
  },
  async action_get_web_columnsList ({ commit, state }) {
    var list = await getFriendLink({
      pageNum: 1,
      pageSize: 999,
      // type: 1,
      types: "1,2,3,4,5,6,7,8,9,10",
      projectId: getProjectId()
    }).then(res => res && res.result && res.result.data)
    var list = list
    // for (let i = 0; i < list.length; i++) {
    //     // /api3/column/getColumnById/{id}
    //     // var item = await ajax.get(`/api3/column/getColumnById/${list[i].id}`)
    //     //     .then(res => res.data).then(res => {
    //     //         return res.result
    //     //     })
    //     // list[i] = {
    //     //     ...list[i],
    //     //     ...item
    //     // }
    // }
    commit("webColunmsList", list)
    var colunmsListObject = {}
    list.map(item => {
      colunmsListObject[item.title] = item
    })

    commit("colunmsListObject", colunmsListObject)
    return list
  }
}

const getters = {
  isDesMobile: state => state.isDesMobile,
  passwordDialog: state => state.passwordDialog,
  projectId: state => state.projectId,
  projectName: state => state.activity.name
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/match/pages/index/store/state.js